// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRedEnvelopeOutlinedSvg from "@fishx/icons-svg/es/asn/PRedEnvelopeOutlined";
import FishxIcon from '../components/FishxIcon';

var PRedEnvelopeOutlined = function PRedEnvelopeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRedEnvelopeOutlinedSvg
  }));
};

PRedEnvelopeOutlined.displayName = 'PRedEnvelopeOutlined';
export default React.forwardRef(PRedEnvelopeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRedEnvelopeOutlined.js
// module id = 3588
// module chunks = 0